import { render, staticRenderFns } from "./baseultimasrespuestasdebito.vue?vue&type=template&id=3fc89f7e"
import script from "./baseultimasrespuestasdebito.vue?vue&type=script&lang=js"
export * from "./baseultimasrespuestasdebito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports